import React, { FC } from 'react'
import { useField, useFormikContext } from 'formik'
import { Label, Input, FormFeedback } from 'reactstrap'

export const TextField: FC<{
  name: string
  label: string
  type?: 'text' | 'number'
  size?: 'sm' | 'lg'
  disabled?: boolean
}> = ({ name, type = 'text', label, disabled = false, size, ...props }) => {
  const { isSubmitting } = useFormikContext()
  const [{ onChange, value, ...field }, { error, touched }, { setTouched }] = useField(name)

  return (
    <div {...props}>
      <Label size={size} for={name}>
        {label}
      </Label>

      <Input
        id={name}
        bsSize={size}
        type={type}
        value={value || ''}
        invalid={!!error && !!touched}
        disabled={disabled || isSubmitting}
        onChange={(x) => {
          onChange(x)
          setTouched(true)
        }}
        {...field}
      />
      {error && touched && <FormFeedback>{error}</FormFeedback>}
    </div>
  )
}
